/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MessagesList_lists$ref = any;
export type MessageKind = "active" | "expired" | "%future added value";
export type DeleteMessageInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type deleteMessageMutationVariables = {|
  input: DeleteMessageInput,
  kind: MessageKind,
|};
export type deleteMessageMutationResponse = {|
  +deleteMessage: ?{|
    +destroyedMessageId: string,
    +lists: {|
      +$fragmentRefs: MessagesList_lists$ref
    |},
  |}
|};
export type deleteMessageMutation = {|
  variables: deleteMessageMutationVariables,
  response: deleteMessageMutationResponse,
|};
*/


/*
mutation deleteMessageMutation(
  $input: DeleteMessageInput!
  $kind: MessageKind!
) {
  deleteMessage(input: $input) {
    destroyedMessageId
    lists {
      ...MessagesList_lists
      id
    }
  }
}

fragment MessageCell_message on Message {
  id
  title
  body
  endDate
  messageableType
  messageDisplay {
    title
    body
    endDate
    id
  }
}

fragment MessagesList_lists on Lists {
  messages(kind: $kind, first: 1000) {
    edges {
      node {
        id
        ...MessageCell_message
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMessageInput!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "kind",
    "type": "MessageKind!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destroyedMessageId",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  {
    "kind": "Variable",
    "name": "kind",
    "variableName": "kind"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteMessageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteMessagePayload",
        "kind": "LinkedField",
        "name": "deleteMessage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MessagesList_lists"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteMessageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteMessagePayload",
        "kind": "LinkedField",
        "name": "deleteMessage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "MessageConnection",
                "kind": "LinkedField",
                "name": "messages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Message",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "messageableType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MessageDisplay",
                            "kind": "LinkedField",
                            "name": "messageDisplay",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "filters": [
                  "kind"
                ],
                "handle": "connection",
                "key": "MessagesList_messages",
                "kind": "LinkedHandle",
                "name": "messages"
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteMessageMutation",
    "operationKind": "mutation",
    "text": "mutation deleteMessageMutation(\n  $input: DeleteMessageInput!\n  $kind: MessageKind!\n) {\n  deleteMessage(input: $input) {\n    destroyedMessageId\n    lists {\n      ...MessagesList_lists\n      id\n    }\n  }\n}\n\nfragment MessageCell_message on Message {\n  id\n  title\n  body\n  endDate\n  messageableType\n  messageDisplay {\n    title\n    body\n    endDate\n    id\n  }\n}\n\nfragment MessagesList_lists on Lists {\n  messages(kind: $kind, first: 1000) {\n    edges {\n      node {\n        id\n        ...MessageCell_message\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cb6949d83aaba08981024024171c2f31';

module.exports = node;
